import { render, staticRenderFns } from "./PsinAdd.vue?vue&type=template&id=1af9dcf3&scoped=true&"
import script from "./PsinAdd.vue?vue&type=script&lang=js&"
export * from "./PsinAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9dcf3",
  null
  
)

export default component.exports